import { createStore, applyMiddleware, compose } from 'redux';
import rootReducers from './reducers';
import thunk from 'redux-thunk';
const initialState = {};
const middleware = [thunk];
let allEnhancers;
allEnhancers = compose(applyMiddleware(...middleware));
const store = createStore(rootReducers, initialState, allEnhancers);
export default store;
